
import React, { useState, useEffect } from 'react';
import App from "../../../App";
import { Link, useHistory, withRouter } from "react-router-dom";
import { FaLongArrowAltLeft } from "react-icons/all";
import {postData, getData} from '../../../services/baseServices'
import { toast } from 'react-toastify';
import ThanaForm from './Form';

const ThanasCreate = () => {
    const [thana, setThana] = useState({
        name: '',
        bn_name: '',
        home_delivery: true,
    })
    const [district, setDistrict] = useState([]);
    const history = useHistory()
    const onFormSubmit = (data) => {
        const params = {
            thana: {
                name: data.name,
                bn_name: data.bn_name,
                district_id: data.district_id,
                home_delivery: data.home_delivery
            }
        }
          postData("thanas", params)
          .then(res => {
            if(res.success) {
              history.push(`/config/thanas/list`);
              toast.success(res.message);
            }
            else {
              toast.error(res.message);
            }
          })
          .catch(errMsg => {
            toast.error(errMsg);
          }); 
    }
    useEffect(() => {
        getData('districts')
          .then(res => {
            setDistrict(res.data)
          })
          .catch(errMsg => {
          })
    }, [])
    return (
        <App layout="boxed">
            <div className="page-header">
                <h2 className="page-title">Create Thana</h2>
                <div className="ml-auto">
                    <Link to={`${process.env.PUBLIC_URL}/config/thanas/list`}
                    className="btn btn-sm btn-link"><FaLongArrowAltLeft/> Back to List</Link>
                </div>
            </div>

            <div className="card-block">
                <div className="block-body">
                    <>
                    <ThanaForm
                        district={district}
                        thana={[]}
                        onFormSubmit = {onFormSubmit}
                    />
                    </>
                </div>
            </div>
        </App>
    );
}
export default withRouter(ThanasCreate);